export const PULSE_INTERVAL_MS = 15_000

export type PulseSnapshot = {
  unreadCount: number
  headId: string | null
}

export const INITIAL_PULSE: PulseSnapshot = {
  unreadCount: 0,
  headId: null,
}

export const shouldInvalidateListOnPulse = (
  previousHeadId: string | null | undefined,
  nextHeadId: string | null
): boolean => previousHeadId !== nextHeadId

export const mergePulseSnapshot = (
  previous: PulseSnapshot,
  next: PulseSnapshot
): PulseSnapshot | null => {
  if (
    previous.unreadCount === next.unreadCount &&
    previous.headId === next.headId
  ) {
    return null
  }
  return next
}
